module.exports = __webpack_public_path__ + "img/img2zhCn.1b8d767d.png";